import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { DataProvider } from "./contexts/DataContext.jsx";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import { LoadingProvider } from "./contexts/LoadingContext.jsx";
import { ColourProvider } from "./contexts/ColourContext.jsx";
import Header from "./global/Header.jsx";
import MenuBar from "./global/MenuBar.jsx";
import Home from "./pages/Home";
import Settings from "./pages/Settings";
import AdminUserMgt from "./pages/AdminUserMgt.jsx";
import DatabaseProducts from "./pages/DatabaseProducts.jsx";
import DatabaseExhibit from "./pages/DatabaseExhibit.jsx";
import DatabaseGuestHouse from "./pages/DatabaseGuestHouse.jsx";
import "../src/styles/index.css";

const wider = "1200px";
const wide = "1000px";
const compact = "500px";

const Layout = () => (
  <Box>
    <Outlet />
    <Header />
    <MenuBar />
  </Box>
);

const App = ({}) => {
  return (
    <Box className="App">
      <ColourProvider>
        <AuthProvider>
          <DataProvider>
            <LoadingProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Layout />}>
                    {/* HOME */}
                    <Route index element={<Home maxWidth={wide} />} />

                    {/* SETTINGS */}
                    <Route
                      path="/settings"
                      element={<Settings maxWidth={compact} />}
                    />

                    {/* ADMIN */}
                    <Route
                      path="/admin"
                      element={<AdminUserMgt maxWidth={compact} />}
                    />

                    {/* DATABASE */}
                    <Route
                      path="/data"
                      element={<DatabaseProducts maxWidth={compact} />}
                    />
                    <Route
                      path="/data/exhibit"
                      element={<DatabaseExhibit maxWidth={compact} />}
                    />
                    <Route
                      path="/data/guest-house"
                      element={<DatabaseGuestHouse maxWidth={compact} />}
                    />
                  </Route>
                </Routes>
              </BrowserRouter>
            </LoadingProvider>
          </DataProvider>
        </AuthProvider>
      </ColourProvider>
    </Box>
  );
};

export default App;
